// @owners { team: patients }
import { DateRestrictionReasonMap } from '@alto/scriptdash/alto/scheduling/types/v1/date_restriction_reason';

export const reasonIsRefillTooSoon = (reason: string) =>
  reason === DateRestrictionReasonMap.REFILL_TOO_SOON || reason === DateRestrictionReasonMap.DELIVERED_RECENTLY;
